import { useEffect } from 'react';
import { taskCollection } from 'collections/tasks';
import { useProjectTasksQuery } from 'queries/task';
export const useProjectTasks = (projectId)=>{
    const { data } = useProjectTasksQuery(projectId, {
        refetchOnMount: 'always'
    });
    useEffect(()=>{
        if (data != null) {
            taskCollection.push(data);
        }
    }, [
        data
    ]);
};
